import React from "react";
import ContactSets from "./ContactSets";

export default function ContactSetsPage() {
  return <ContactSets contactSetButton={null} isModal={false} />;
}
